import React from "react";
import { Link } from "react-router-dom";
import { LinkIcon } from "lucide-react";
import { getContextualLinks } from "../data/priorityLinks";

// Contextual in-copy internal-linking block. `topic` selects a relevant,
// small set of links (3–6) for the page — not the same six links sitewide.
const RelatedClaimHelp = ({
  topic = "generic",
  currentPath,
  heading = "Related Claim Help",
}) => {
  const links = getContextualLinks(topic, currentPath);
  if (links.length < 2) return null;

  return (
    <section
      className="py-12 bg-[#0A0A0A] border-t border-white/10"
      data-testid="related-claim-help"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="flex items-center gap-2 mb-4">
          <LinkIcon className="h-4 w-4 text-[#E11D26]" />
          <span className="text-[#E11D26] text-xs font-bold tracking-[0.25em] uppercase">
            {heading}
          </span>
        </div>
        <p className="text-white/75 text-sm sm:text-base leading-relaxed">
          Fighting a claim in the Tampa Bay area? Explore our{" "}
          {links.map((l, i) => (
            <React.Fragment key={l.to}>
              <Link
                to={l.to}
                className="text-[#E11D26] hover:text-white underline underline-offset-2 font-semibold transition-colors"
              >
                {l.anchor}
              </Link>
              {i < links.length - 2 ? ", " : i === links.length - 2 ? ", and " : "."}
            </React.Fragment>
          ))}
        </p>
      </div>
    </section>
  );
};

export default RelatedClaimHelp;
